import { render, staticRenderFns } from "./PurchaseAdd.vue?vue&type=template&id=61502a84&"
import script from "./PurchaseAdd.vue?vue&type=script&lang=js&"
export * from "./PurchaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAdd.vue?vue&type=style&index=0&id=61502a84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports